import { render, staticRenderFns } from "./StudyPage.vue?vue&type=template&id=26928f36&scoped=true&"
import script from "./StudyPage.vue?vue&type=script&lang=js&"
export * from "./StudyPage.vue?vue&type=script&lang=js&"
import style0 from "./StudyPage.vue?vue&type=style&index=0&id=26928f36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26928f36",
  null
  
)

export default component.exports